import { Box, Button, CircularProgress, Stack } from "@mui/material";

const ModalSubmitFooter = ({ onCancel, loading }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button onClick={onCancel} color="error">
          Hủy bỏ
        </Button>
        <Button
          variant="contained"
          type="submit"
          disabled={loading}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {loading && <CircularProgress size={16} />}
          Đồng ý
        </Button>
      </Stack>
    </Box>
  );
};

export default ModalSubmitFooter;
